import { FC } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { absolutePath } from "app/helpers/relativePath";
import { FIRM_CASH_BOOK_LIST } from "app/helpers/routes";
import { KTSVG } from "_metronic/helpers";
import StatusCell from "app/components/commonComponent/table/StatusCell";
import { connect } from "react-redux";
import UserActionsCell from "app/components/commonComponent/table/UserActionsCell";
import { updateCashBookStatus } from "app/reducers/cashBook/cashBookAction";

interface props {
  row: any;
  updateStatusDispatch: Function;
}

const CashBookTableRow: FC<props> = ({ updateStatusDispatch, row }) => {
  const navigate = useNavigate();
  const params = useParams();

  const handleEditData = () => {
    navigate(
      absolutePath(`${FIRM_CASH_BOOK_LIST}/${params.id}/edit/${row.Id}`)
    );
  };

  const handleViewTransaction = () => {
    navigate(
      absolutePath(`${FIRM_CASH_BOOK_LIST}/${params.id}/transaction/${row.Id}`)
    );
  };

  const updateList = (id: number, callBack: Function) => {
    updateStatusDispatch(row.Id, callBack);
  };

  return (
    <tr>
      <td className="text-dark fw-bold ps-2">{row.Name}</td>
      <td>
        <StatusCell isActive={row.IsActive} />
      </td>
      <td>
        <div className="d-flex gap-3 justify-content-end pe-5">
          <button
            className={`p-2 btn btn-icon btn-bg-light btn-sm btn-active-light-primary`}
            title="Edit"
            onClick={handleEditData}
          >
            <KTSVG
              path="/media/icons/duotune/art/art005.svg"
              className="svg-icon-3"
            />
          </button>
          <UserActionsCell
            updateStatusDispatch={updateList}
            isActive={row?.IsActive}
            id={row?.Id}
          />
          <button
            className="w-150px btn btn-active-light-primary btn-bg-light btn-sm fs-6 text-gray-600 text-hover-primary"
            title="View Transaction"
            onClick={handleViewTransaction}
          >
            View Transaction
          </button>
        </div>
      </td>
    </tr>
  );
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    updateStatusDispatch: (bankBookId: number, successCallback: Function) =>
      dispatch(updateCashBookStatus(bankBookId, successCallback)),
  };
};

export default connect(null, mapDispatchToProps)(CashBookTableRow);
